<div class="container-fluid">
  <app-shop-search
    [implementationPage]="'iframe'"
    [bookingParameters]="bookingParameters"
    [hidePromocode]="hidePromocode"
    [refererId]="refererId"
    [maxAllowedChildren]="maxAllowedChildren"
    [maxAllowedPersons]="maxAllowedPersons"
    [alwaysReportSearches]="alwaysReportSearches"
    [allowMinification]="false"
    [disableSearch]="disableSearch"
    (sentForm)="updateForm($event)">
  </app-shop-search>
  @if (showLogo) {
    <img class="logo float-right" src="{{ 'images/alpinresorts-logo-desktop.svg' | platformasset: true }}" />
  }
</div>
